/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
import React, {
 useContext, useEffect, useState, useMemo 
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { useHistory } from 'react-router-dom'
import { Button } from '@telus/koodo-ui-kit'
import { APPLICATION_STATE, ApplicationContext, setActivateAllTrigerred } from '@apps/contexts/ApplicationContext'
import { ACCOUNT_SETUP_STATE } from '@apps/redux/features/AccountSetupSlice'
import { PHONE_NUMBER_STATE } from '@apps/redux/features/PhoneNumberSlice'
import { PAYMENT_STATE, updatePaymentStates } from '@apps/redux/features/PayAndReviewSlice'
import { PLANS_STATE } from '@apps/redux/features/PlansSlice'
import { getById, getBySlug } from '@apps/utils/contentful'
import { getCardValidationParams } from '@apps/utils/requestPayloadHelper'
import RegistrationPayment from '@apps/flows/activation/services/registerPaymentHelper'
import { PAYMENT_OPTIONS, ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import { setPageAnalytics } from '@apps/utils/Analytics'
import useSite from '@engine/hooks/useSite'
import { getPromoNames } from '@apps/utils/common'
import ConsumerActivationPaths from '@/sites/consumer/activation/ConsumerActivationPaths'
import Sites from '@/sites'
import DealerActivationPaths from '@/sites/dealer/activation/DealerActivationPaths'
import useTagManagerInfo from '../../../../_engine/hooks/useTagManagerInfo'


const ActivateSIMSection = ({
  showAllErrors = () => {},
  handleSIMActivation,
  setShowActivatingPopup,
  setIsProcessingPayment,
  setIActivateButtonDisabled,
  paymentGateway,
  isActivateButtonDisabled,
  setIsActivateAllProcessing,
  buttonIsLoading,
  setButtonIsLoading
}) => {
  const contextState = {
    application: useContext(ApplicationContext),
    accountSetup: useSelector((state) => state.accountSetupPage),
    phoneNumber: useSelector((state) => state.phoneNumberPage),
    plans: useSelector((state) => state.plansPage),
    payment: useSelector((state) => state.payAndReviewPage)
  }

  const {
    [PAYMENT_STATE.SELECTED_PAYMENT_OPTION]: selectedPaymentOption,
    [PAYMENT_STATE.AUTO_TOP_UPS]: autoPay,
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: multiPromotionCodeInfo
  } = contextState.payment

  const { 
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region
  } = useContext(ApplicationContext)

  const { processPayment } = brandServices

  const voucherAutoPaySelected = selectedPaymentOption === PAYMENT_OPTIONS.VOUCHER && autoPay

  const history = useHistory()
  const site = useSite()
  const consumerActivationPaths = new ConsumerActivationPaths()
  const dealerActivationPaths = new DealerActivationPaths()

  const dispatch = useDispatch()
  const [paymentParams, setPaymentParams] = useState({})
  const [isComplete, setIsComplete] = useState(false)
  const location = useLocation()

  const updatePaymentStore = (payload) => {
    dispatch(updatePaymentStates(payload))
  }

  const {
    content: { pageContent, featureFlags },
    user: { selectedLanguage },
    userType
  } = useSelector((state) => state.common)

  const isDealer = userType === Sites.dealer
  const pagePrefix = isDealer ? 'Dealer' : 'Consumer'
  const textContent = useMemo(() => {
    if (!pageContent) return {}
    const paymentPage = getById(pageContent, `paymentPage${pagePrefix}`)?.[selectedLanguage]
    const { shortTextFields } = paymentPage || {}
    return {
      activateSim: getBySlug(shortTextFields, 'activateSim')?.value
    }
  }, [pageContent, selectedLanguage])

  const { activateSim } = textContent

  const tagManagerInfo = useTagManagerInfo()

  // eslint-disable-next-line camelcase
  const pushClickAnalytics = ({ click_text, promoCodeDescription, event_type, target_link, event_click = ANALYTICS_EVENT_TYPES.CLICK } = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text,
        promoCodeDescription
      }, event_type, event_click, target_link)
    )
  }

  const activateAllHandler = async () => {
    pushClickAnalytics({ click_text: activateSim, promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Activate Sim card clicked' })
    // Read from the feature flags already in Redux rather than calling Contentful
    // from the browser. getAllPagesData fetches them server-side and scopes them
    // to this portal, so no consumer/dealer branch is needed here. It also keeps
    // a Contentful outage from rejecting inside this click handler, which
    // silently aborted activation.
    if (featureFlags?.[0]?.showSplashing) {
      setIsActivateAllProcessing(false)
      history.push(
        site === Sites.consumer
          ? consumerActivationPaths.Splash
          : dealerActivationPaths.Splash
      )
      return
    }
    if (contextState?.payment?.isComplete) {
      if (selectedPaymentOption === PAYMENT_OPTIONS.CREDIT_CARD || voucherAutoPaySelected) {
        const cardParams = getCardValidationParams(contextState)
        const generatedParams = await RegistrationPayment.generateParams(
          ...Object.values(cardParams)
        )
        setPaymentParams(generatedParams)
        setIsProcessingPayment(true)
        setShowActivatingPopup(false)
        setIActivateButtonDisabled(true)

        const paymentResult = await processPayment(generatedParams)
        await handleSIMActivation(paymentResult)
      } else {
        setActivateAllTrigerred(true)
        setButtonIsLoading(true)
        await handleSIMActivation()
      }
    } else if (paymentGateway === 'EPS') {
      if (
        contextState.accountSetup[ACCOUNT_SETUP_STATE.IS_COMPLETE] &&
        contextState.phoneNumber[PHONE_NUMBER_STATE.IS_COMPLETE] &&
        contextState.plans[PLANS_STATE.PLAN].id &&
        !contextState.payment[PAYMENT_STATE.IS_COMPLETE]
      ) {
        updatePaymentStore({
          [PAYMENT_STATE.PAYMENT_SCROLL_TO_ERR_FIELD]: null
        })
        showAllErrors()
      } else {
        showAllErrors()

        setIsActivateAllProcessing(false)

        setButtonIsLoading(false)

        if (userType === Sites.consumer) {
          history.push(consumerActivationPaths.ProcessFailure)
        } else if (userType === Sites.dealer) {
          history.push(dealerActivationPaths.ProcessFailure)
        }
      }

      //  setButtonIsLoading(false)
    } else {
      showAllErrors()

      setIsActivateAllProcessing(false)
      setButtonIsLoading(false)
    }

  }

  useEffect(() => {
    if (contextState.plans && contextState.plans[PLANS_STATE.PLAN]) {
      setIsComplete(
        contextState.accountSetup[ACCOUNT_SETUP_STATE.IS_COMPLETE] &&
          contextState.phoneNumber[PHONE_NUMBER_STATE.IS_COMPLETE] &&
          contextState.plans[PLANS_STATE.PLAN].id &&
          contextState.payment[PAYMENT_STATE.IS_COMPLETE]
      )
    }
  })

  return (
    <div className="flex flex-col w-full space-y-4">
      <div className="flex flex-row">
        <div className="w-full sm:w-auto">
          <Button
            onPress={activateAllHandler}
            inactive={isActivateButtonDisabled}
            loading={contextState?.payment?.isCompleteEPS && buttonIsLoading}
            variant={{ width: 'full' }}
            tokens={{ backgroundColor: '#000000', color: '#ffffff', borderColor: '#000000' }}
            testId="payment-activateButton"
          >
            {activateSim}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ActivateSIMSection
